import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { ListingCategory, ListingCategoryGroup } from '../../../../models/inModels/MarketPlaceModel';
import { ListingCategoryService } from '../../../../services/listing-categories/listing-category.service';

@Component({
  selector: 'app-edit-category-group',
  templateUrl: './edit-category-group.component.html',
})
export class EditCategoryGroupComponent implements OnInit {
  model: ListingCategoryGroup;
  loading = false;
  error: Message[];
  messages: Message[];
  id: number;
  items: ListingCategory[] = [];
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ListingCategoryService) {
    this.model = new ListingCategoryGroup();
  }

  ngOnInit() {
    this.loading = true;
    this.id = this.route.snapshot.params.Id;
    this.service.get(this.id).then(
      res => {
        this.model = new ListingCategoryGroup(res);
        this.items = this.model.ListingCategories;
        console.log("Listing Category Group to edit", this.model);
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.messages = [];
        this.messages.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  goBack(): void {
    this.router.navigate(['/marketplace/listing-category/group']);
  }

  save() {
    this.loading = true;
    this.service.update(this.model).then(
      res => {
        this.model = new ListingCategoryGroup(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  edit(option: ListingCategory) {
    this.router.navigate(['/marketplace/listing-category/edit', option.Id]);
  }

  handleIconImage(event): void {
    var result = this.storageService.handleSuccess(event);
    this.model.IconId = result.PublicId;
    this.loading = false;
  }
    

  handleDisplayImage(event): void {
    var result = this.storageService.handleSuccess(event);
    this.model.ImageId = result.PublicId;
    this.loading = false;
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/listing-categories/edit/edit-group/edit-category-group.component.ts